import { Button, DatePicker, Form, Input, Select, TimePicker, Typography } from "antd";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";

const { TextArea } = Input;
const { Title } = Typography;
const { Option } = Select;

const AddMeeting = ({ form, onSubmit }) => {
	const dispatch = useDispatch();
	const [loader, setLoader] = React.useState(false);
	const staffList = useSelector((state) => state.users?.list || []);

	useEffect(() => {
		dispatch(loadAllStaff({ status: true }));
	}, [dispatch]);

	const onFinish = async (values) => {
		try {
			setLoader(true);
			const meetingData = {
				...values,
				meetingDate: dayjs(values.meetingDate).format("YYYY-MM-DD"),
				meetingTime: values.meetingTime ? dayjs(values.meetingTime).format("HH:mm") : null,
				status: values.status || "Scheduled",
			};

			if (onSubmit) {
				onSubmit(meetingData);
				toast.success("Meeting Scheduled Successfully!");
			}
		} catch (error) {
			toast.error("Failed to schedule meeting");
		} finally {
			setLoader(false);
		}
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning("Please fill all required fields");
		setLoader(false);
	};

	return (
		<div className="column-design border rounded card-custom">
			<Title level={4} className="m-2 mt-5 mb-5 text-center">
				Schedule Meeting
			</Title>
			<Form
				form={form}
				style={{ marginBottom: "40px" }}
				name="meeting-form"
				labelCol={{ span: 8 }}
				wrapperCol={{ span: 16 }}
				onFinish={onFinish}
				onFinishFailed={onFinishFailed}
				autoComplete="off"
				preserve={false}
			>
				<Form.Item
					label={<span className="required-label">Manager</span>}
					name="managerId"
					rules={[
						{ required: true, message: "Please select a manager!" },
					]}
				>
					<Select
						placeholder="Select manager"
						showSearch
						filterOption={(input, option) =>
							(option?.children ?? "")
								.toLowerCase()
								.includes(input.toLowerCase())
						}
					>
						{staffList?.map((staff) => {
							const staffId =
								staff.id ??
								staff.EmployeeId ??
								staff.EmployeeID ??
								staff.UserId ??
								staff.UserID;
							return (
								<Option key={staffId} value={staffId}>
									{staff.EmployeeName ||
										`${staff.firstName || ""} ${staff.lastName || ""}`.trim() ||
										staff.UserName}
								</Option>
							);
						})}
					</Select>
				</Form.Item>

				<Form.Item
					label={<span className="required-label">Employee</span>}
					name="employeeId"
					rules={[
						{ required: true, message: "Please select an employee!" },
					]}
				>
					<Select
						placeholder="Select employee"
						showSearch
						filterOption={(input, option) =>
							(option?.children ?? "")
								.toLowerCase()
								.includes(input.toLowerCase())
						}
					>
						{staffList?.map((staff) => {
							const staffId =
								staff.id ??
								staff.EmployeeId ??
								staff.EmployeeID ??
								staff.UserId ??
								staff.UserID;
							return (
								<Option key={staffId} value={staffId}>
									{staff.EmployeeName ||
										`${staff.firstName || ""} ${staff.lastName || ""}`.trim() ||
										staff.UserName}
								</Option>
							);
						})}
					</Select>
				</Form.Item>

				<Form.Item
					label={<span className="required-label">Meeting Date</span>}
					name="meetingDate"
					rules={[
						{ required: true, message: "Please select meeting date!" },
					]}
				>
					<DatePicker
						style={{ width: "100%" }}
						format="DD-MM-YYYY"
						disabledDate={(current) => current && current < dayjs().startOf("day")}
					/>
				</Form.Item>

				<Form.Item
					label={<span className="required-label">Meeting Time</span>}
					name="meetingTime"
					rules={[
						{ required: true, message: "Please select meeting time!" },
					]}
				>
					<TimePicker
						style={{ width: "100%" }}
						format="HH:mm"
					/>
				</Form.Item>

				<Form.Item
					label={<span className="required-label">Location</span>}
					name="location"
					rules={[
						{ required: true, message: "Please enter meeting location!" },
					]}
				>
					<Input placeholder="Enter meeting location (e.g., Conference Room A, Zoom)" />
				</Form.Item>

				<Form.Item
					label={<span className="required-label">Agenda</span>}
					name="agenda"
					rules={[
						{ required: true, message: "Please enter meeting agenda!" },
					]}
				>
					<TextArea
						rows={3}
						placeholder="Enter meeting agenda"
						maxLength={500}
						showCount
					/>
				</Form.Item>

				<Form.Item
					label="Notes"
					name="notes"
				>
					<TextArea
						rows={2}
						placeholder="Enter any additional notes"
						maxLength={300}
						showCount
					/>
				</Form.Item>

				<Form.Item
					label="Status"
					name="status"
					initialValue="Scheduled"
				>
					<Select>
						<Option value="Scheduled">Scheduled</Option>
						<Option value="Completed">Completed</Option>
						<Option value="Cancelled">Cancelled</Option>
						<Option value="Postponed">Postponed</Option>
					</Select>
				</Form.Item>

				<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
					<Button
						type="primary"
						size="large"
						htmlType="submit"
						block
						loading={loader}
					>
						Schedule Meeting
					</Button>
				</Form.Item>
			</Form>
		</div>
	);
};

export default AddMeeting;

